import { RouterState } from 'mobx-state-router';
import { getLoginRoute } from 'core/utils';
import _ from 'lodash';

async function resolvePlatformUser(fromState, toState, routerStore) {
	const authStore = routerStore.rootStore.authStore;
	await authStore.initialize();

	const app = routerStore.rootStore.app.baasic;

	const isAppUser = u => u.isApplicationUser !== undefined && u.isApplicationUser === true;
	const resolveUnauthorized = () =>
		authStore.isAuthenticated
			? Promise.reject(new RouterState('unauthorized'))
			: Promise.reject(new RouterState('master.app.membership.login'));

	if (authStore.isAuthenticated) {
		var user = app.getUser();
		user = user !== null && user !== undefined ? user.user : null;

		if (user === undefined || user === null) {
			try {
				const response = await app.membershipModule.login.loadUserData({ embed: 'permissions' });
				const user = response.data;
				if (isAppUser(user)) {
					return resolveUnauthorized();
				}

				// const applications = await app.applicationSettingModule.find({
				// 	pageNumber: 1,
				// 	pageSize: 1000,
				// 	orderBy: 'dateCreated',
				// 	orderDirection: 'desc',
				// });
				// user.applications = applications.data.item;

				authStore.setUser(user);
				return Promise.resolve();
			} catch (ex) {
				const { statusCode } = ex;
				if (statusCode === 401) {
					return resolveUnauthorized();
				} else {
					routerStore.rootStore.errorStore.setErrors({
						Error: 'INTERNALERROR',
					});
					return Promise.reject(new RouterState('master.error'));
				}
			}
		}

		authStore.setUser(user);
		return Promise.resolve();
	}

	return resolveUnauthorized();
}

async function resolveApplicationUser(fromState, toState, routerStore) {
	const {
		authStore,
		app: { baasic: baasicApplication },
	} = routerStore.rootStore;

	const resolveUnauthorized = () =>
		authStore.isAuthenticated
			? Promise.reject(new RouterState('unauthorized'))
			: Promise.reject(getLoginRoute(baasicApplication.getApiKey()));

	let user = null;
	if (authStore.isAuthenticated) {
		try {
			const response = await baasicApplication.membershipModule.login.loadUserData({ embed: 'permissions' });
			user = {
				...response.data,
				displayName: _.split(response.data.userName, '-')[0],
				isApplicationUser: true,
				apiKey: baasicApplication.getApiKey(),
			};
			await authStore.setUser(user);
			return Promise.resolve();
		} catch (ex) {
			const { statusCode } = ex;
			if (statusCode === 401) {
				authStore.resetPermissions();
				authStore.setUser(null);
				return resolveUnauthorized();
			} else {
				routerStore.rootStore.errorStore.setErrors({
					Error: 'INTERNALERROR',
				});
				return Promise.reject(new RouterState('master.error'));
			}
		}
	}

	return resolveUnauthorized();
}

export { resolvePlatformUser, resolveApplicationUser };



// WEBPACK FOOTER //
// ./src/core/utils/router/resolveUser.js